/** @format */
import { Hyperlink } from '@contentful/rich-text-types';
import { Link } from '@mpb-com/feather/components/atoms/link';
import { LinkProps } from '@mpb-com/feather/components/atoms/link/types';
import React, { ReactNode } from 'react';

export const ContentfulLink = (
    node: Hyperlink,
    children: ReactNode,
    linkProps?: LinkProps
) => {
    return (
        <Link href={node?.data?.uri} {...linkProps}>
            {children}
        </Link>
    );
};
